export enum LocalStorageKey {
  TOKEN = 'TOKEN',
  SPECIFIC_EMAILS = 'SPECIFIC_EMAILS',
  EXCEPT_EMAILS = 'EXCEPT_EMAILS',
}
